import React from "react";

// Brutalist monogram — white on black or black on white.
export default function BrandMark({ size = 28, inverted = false }) {
  const fg = inverted ? "#fff" : "#0A0A0A";
  const bg = inverted ? "#0A0A0A" : "#fff";
  return (
    <span
      data-testid="brand-mark"
      className="inline-flex items-center gap-2 select-none"
      aria-label="1OS"
    >
      <span
        style={{
          width: size, height: size, background: fg, color: bg,
          fontFamily: "Chivo, sans-serif",
          fontWeight: 900,
          fontSize: size * 0.5,
          letterSpacing: "-0.04em",
        }}
        className="flex items-center justify-center"
      >
        1<span style={{ marginLeft: 1 }}>○</span>S
      </span>
    </span>
  );
}
